/* Tuuli — Line Item Properties: translations + UX (robust locales, update-proof) */
(function () {
  // ---- 1) Translation dictionary -----------------------------------------
  // Use base language keys AND common region variants.
  var T = {
    // BASE KEYS (catch both 'de' and 'de-DE', etc.)
    de: { label: 'Personalisierter Text', placeholder: 'Geben Sie hier Ihren personalisierten Text ein. Bei Schneidebrettern können Sie Text in mehreren Zeilen hinzufügen.' },
    fr: { label: 'Texte personnalisé', placeholder: 'Saisissez ici votre texte personnalisé. Pour les planches, vous pouvez ajouter du texte sur plusieurs lignes.' },
    it: { label: 'Testo personalizzato', placeholder: 'Inserisci qui il tuo testo personalizzato. Per i taglieri puoi aggiungere testo su più righe.' },
    es: { label: 'Texto personalizado', placeholder: 'Escribe aquí tu texto personalizado. En las tablas de cortar puedes añadir texto en varias líneas.' },
    nl: { label: 'Gepersonaliseerde tekst', placeholder: 'Typ hier je gepersonaliseerde tekst. Voor snijplanken kun je tekst over meerdere regels toevoegen.' },
    pt: { label: 'Texto personalizado', placeholder: 'Escreva aqui o seu texto personalizado. Nas tábuas de corte pode adicionar texto em várias linhas.' },
    sv: { label: 'Personlig text', placeholder: 'Skriv din personliga text här. För skärbrädor kan du lägga till text på flera rader.' },
    fi: { label: 'Personoitu teksti', placeholder: 'Kirjoita oma personoitu tekstisi tähän. Leikkuulaudoille voit lisätä tekstiä useille riveille.' },
    da: { label: 'Personlig tekst', placeholder: 'Skriv din personlige tekst her. Til skærebrætter kan du tilføje tekst over flere linjer.' },
    no: { label: 'Personlig tekst', placeholder: 'Skriv inn din personlige tekst her. På skjærebrett kan du legge til tekst i flere linjer.' },
    pl: { label: 'Tekst personalizowany', placeholder: 'Wpisz tutaj swój spersonalizowany tekst. Na deskach do krojenia możesz dodać tekst w kilku liniach.' },
    cs: { label: 'Personalizovaný text', placeholder: 'Sem zadejte svůj personalizovaný text. U prkének můžete přidat text na více řádků.' },
    sk: { label: 'Personalizovaný text', placeholder: 'Sem zadajte svoj personalizovaný text. Pri doskách môžete pridať text na viacerých riadkoch.' },
    hu: { label: 'Személyre szabott szöveg', placeholder: 'Ide írja be a személyre szabott szöveget. Vágódeszkára több soros szöveget is megadhat.' },
    ro: { label: 'Text personalizat', placeholder: 'Introduceți aici textul personalizat. Pentru tocătoare puteți adăuga text pe mai multe rânduri.' },
    el: { label: 'Προσωποποιημένο κείμενο', placeholder: 'Πληκτρολογήστε εδώ το προσωπικό σας κείμενο. Για ξύλα κοπής μπορείτε να προσθέσετε κείμενο σε πολλές γραμμές.' },
    tr: { label: 'Kişiselleştirilmiş metin', placeholder: 'Kişiselleştirilmiş metninizi buraya yazın. Kesme tahtalarında birden fazla satır ekleyebilirsiniz.' },
    uk: { label: 'Персоналізований текст', placeholder: 'Введіть тут свій персоналізований текст. Для обробних дощок можна додати текст у кілька рядків.' },
    ja: { label: '名入れテキスト', placeholder: 'こちらに名入れテキストをご入力ください。まな板では複数行のテキストも追加できます。' },
    ar: { label: 'نص مخصص', placeholder: 'اكتب نصك المخصص هنا. في ألواح التقطيع يمكنك إضافة نص في عدة أسطر.' },

    // EN is the global fallback
    en: { label: 'Personalized text', placeholder: 'Type your personalized text here…' },

    // REGION OVERRIDES where wording differs (optional)
    'pt-br': { label: 'Texto personalizado', placeholder: 'Digite aqui seu texto personalizado. Em tábuas de corte você pode adicionar texto em várias linhas.' },
    'es-mx': { label: 'Texto personalizado', placeholder: 'Escribe aquí tu texto personalizado. En tablas para cortar puedes añadir texto en várias linhas.' },
    'fr-be': { label: 'Texte personnalisé', placeholder: 'Saisissez ici votre texte personnalisé. Pour les planches, vous pouvez ajouter du texte sur plusieurs lignes.' },
    'de-at': { label: 'Personalisierter Text', placeholder: 'Geben Sie hier Ihren personalisierten Text ein. Bei Schneidebrettern können Sie Text in mehreren Zeilen hinzufügen.' },
    'de-ch': { label: 'Personalisierter Text', placeholder: 'Geben Sie hier Ihren personalisierten Text ein. Bei Schneidebrettern können Sie Text in mehreren Zeilen hinzufügen.' }
  };

  // ---- 2) Locale normalization --------------------------------------------
  function normalizeLocale(lang) {
    if (!lang) return 'en';
    var l = String(lang).toLowerCase().replace('_', '-');
    var alias = { 'tr-tu': 'tr-tr', 'uk-uk': 'uk-ua', 'ar-ar': 'ar-sa' };
    if (alias[l]) l = alias[l];
    return l;
  }

  function chooseStrings(lang) {
    var L = normalizeLocale(lang);
    if (T[L]) return T[L];
    var base = L.split('-')[0];
    if (T[base]) return T[base];
    return T.en;
  }

  // ---- 3) Apply translations + UX ------------------------------------------
  function applyTranslations(scope) {
    var root = scope || document;
    var lang = document.documentElement.getAttribute('lang') || '';
    var s = chooseStrings(lang);

    root.querySelectorAll('.line-item-properties .property, .line-item-property .form-control')
      .forEach(function (wrap) {
        var label = wrap.querySelector('label, .floating-label');
        var input = wrap.querySelector('input[type="text"], textarea');
        if (!input) return;

        if (label) label.textContent = s.label;
        input.setAttribute('name', 'properties[' + s.label + ']');
        input.setAttribute('placeholder', s.placeholder);
      });
  }

  function toggleState(el) {
    var wrap = el.closest('.line-item-properties .property, .line-item-property .form-control');
    if (!wrap) return;
    wrap.classList.toggle('has-value', (el.value || '').trim().length > 0);
  }

  function bindUX(scope) {
    var root = scope || document;
    root.querySelectorAll('.line-item-properties input[type="text"], .line-item-properties textarea, .line-item-property input[type="text"], .line-item-property textarea')
      .forEach(function (el) { toggleState(el); });

    document.addEventListener('input', function (e) {
      if (e.target.matches('.line-item-properties input[type="text"], .line-item-properties textarea, .line-item-property input[type="text"], .line-item-property textarea')) {
        toggleState(e.target);
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches('.line-item-properties input[type="text"], .line-item-properties textarea, .line-item-property input[type="text"], .line-item-property textarea')) {
        toggleState(e.target);
      }
    });
  }

  function init(e) {
    var scope = e && e.target ? e.target : document;
    applyTranslations(scope);
    bindUX(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();

/* Tuuli — Strip Shopify recommendations tracking params (?pr_*) from product links */
(function () {
  function isInternalProductUrl(u) {
    if (!u || u.origin !== window.location.origin) return false;
    return u.pathname.indexOf("/products/") !== -1;
  }

  function hasPrParams(u) {
    for (const k of u.searchParams.keys()) {
      if (String(k).toLowerCase().startsWith("pr_")) return true;
    }
    return false;
  }

  function stripPrParams(u) {
    let changed = false;
    const keys = Array.from(u.searchParams.keys());
    for (const k of keys) {
      if (String(k).toLowerCase().startsWith("pr_")) {
        u.searchParams.delete(k);
        changed = true;
      }
    }
    if (!changed) return null;

    const qs = u.searchParams.toString();
    return u.pathname + (qs ? "?" + qs : "") + (u.hash || "");
  }

  function cleanAnchor(a) {
    if (!a) return false;

    const raw = a.getAttribute("href");
    if (!raw) return false;

    // Ignore anchors and special protocols
    const lower = raw.toLowerCase();
    if (
      lower.startsWith("#") ||
      lower.startsWith("mailto:") ||
      lower.startsWith("tel:") ||
      lower.startsWith("javascript:")
    ) return false;

    let u;
    try {
      u = new URL(raw, window.location.origin);
    } catch (e) {
      return false;
    }

    if (!isInternalProductUrl(u)) return false;
    if (!u.search || u.search.indexOf("pr_") === -1) return false;
    if (!hasPrParams(u)) return false;

    const cleaned = stripPrParams(u);
    if (!cleaned) return false;

    // Keep href relative (nice for copy/link display)
    a.setAttribute("href", cleaned);
    return true;
  }

  function scan(root) {
    const scope = root || document;
    scope.querySelectorAll('a[href*="pr_"]').forEach(cleanAnchor);
  }

  function cleanCurrentUrlBar() {
    if (window.location.pathname.indexOf("/products/") === -1) return;
    if (!window.location.search || window.location.search.indexOf("pr_") === -1) return;

    const u = new URL(window.location.href);
    if (!hasPrParams(u)) return;

    const cleaned = stripPrParams(u);
    if (!cleaned) return;

    // No reload, just clean address bar
    window.history.replaceState({}, "", cleaned);
  }

  // Run once
  cleanCurrentUrlBar();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(document); });
  } else {
    scan(document);
  }

  // Clean at click-time (covers dynamic injections)
  document.addEventListener("click", function (e) {
    const a = e.target && e.target.closest ? e.target.closest("a") : null;
    if (a) cleanAnchor(a);
  }, true);

  // Clean when recommendations HTML is injected
  let scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan(document);
    });
  }

  const mo = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        scheduleScan();
        break;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
